<template>
  <div class="app">
    <div class="site-container" :class="{'is-inactive': state.isMobileMenuShowing}">
      <div class="aside">
        <SidebarAppContainer
          :onToggleMenu="onToggleMenu"
          :stateSidebar="state" />
      </div>
      <div class="router-slot">
        <NavbarContainer
          :onToggleMenu="onToggleMenu"
          :stateSidebar="state" />
        <router-view class="router-container" />
      </div>
    </div>
  </div>
</template>

<script>
import NavbarContainer from '@/components/NavbarContainer.vue';
import SidebarAppContainer from '@/components/SidebarAppContainer.vue';

export default {
  components: {
    NavbarContainer,
    SidebarAppContainer,
  },
  data() {
    return {
      state: {
        isMobileMenuShowing: false,
        isLoading: false,
      },
    };
  },
  watch: {
    $route() {
      this.state.isMobileMenuShowing = false;
    },
  },
  methods: {
    onToggleMenu(stateOfMobileShowing) {
      this.state.isMobileMenuShowing = stateOfMobileShowing;
    },
  },
};
</script>

<style lang="scss">
@import './src/assets/scss/app.scss';
@import './src/assets/scss/variables.scss';
// @import './src/assets/scss/aside.scss';
.site-container {
  display: flex;

  .aside {
    width: 250px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
  }

  .router-slot {
    margin-left: 250px;
    width: 100%;
    min-height: calc(100vh - 53px);
  }
}


@media (max-width: 991.98px) {
  .site-container {
    display: flex;

    .aside {
      margin-left: -250px;
    }

    .router-slot {
      margin-left: 0;
    }
  }

  .is-inactive {
    .aside {
      margin-left: 0;
      z-index: 102;
    }

    .router-slot {
      margin-left: 0;
    }
  }
}
</style>
